import React from 'react';
import { Typography } from 'tfc-components';

import Section from 'components/organisms/Section';

const Banner:React.FC = () => (
  <Section className="p-contact_banner">
    <Section.Title white className="p-contact_banner_headTitle">
      Contact Us
    </Section.Title>
    <Typography.Text extendClasses="f-20x24 p-contact_banner_title">We’d love to hear from you.</Typography.Text>
    <Typography.Text extendClasses="f-20x24 p-contact_banner_title">Whether you’re curious about our products, looking to partner, or exploring new opportunities, reach out. We’re building bold things, and we’re always open to great conversations.</Typography.Text>

  </Section>
  );

export default Banner;
